import { createContext, useContext } from 'react';
const LoggerContext = createContext(undefined);
export const useLoggerContext = () => {
    const context = useContext(LoggerContext);
    if (context === undefined) {
        throw new Error('useLoggerContext must be used within a LoggerProvider');
    }
    return context;
};
export default LoggerContext;
